import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Filter out Figma-specific props that shouldn't be passed to DOM elements
 * Includes all known Figma debugging props
 */
export function filterFigmaProps<T extends Record<string, any>>(props: T): T {
  const filteredProps = { ...props };
  
  // Remove all Figma-specific props (all case variations)
  // These props start with _fg and are used by Figma's inspector
  Object.keys(filteredProps).forEach(key => {
    // Match _fg in any case combination (_fg, _FG, _fG, _Fg, _fgT, _fgS, _fgB, etc.)
    if (key.toLowerCase().startsWith('_fg')) {
      delete filteredProps[key];
    }
  });
  
  return filteredProps;
}